import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  ButtonS,
  Content,
  ImgWrap,
  Section,
  TextDiv,
  TwoBtns,
} from "../../styles/Common";
import { styled } from "styled-components";
import OnePageLayout from "../../components/layout/OnePageLayout";
import withDrawalImg from "../../styles/images/img_withdrawal.png";
import { FuncModal } from "../../components/modal/Modal";
import { getToken, returnLoginStatus } from "../../components/hooks/authFunc";
import { useDispatch, useSelector } from "react-redux";
import { authActions } from "../../store/slices/authSlice";
import useDidMountEffect from "../../components/hooks/useDidMountEffect";
import TopPointBanner from "../../components/main/TopPointBanner";

const WithDrawal = () => {
  const dispatch = useDispatch();
  const accessToken = getToken();
  let navigate = useNavigate();
  const isLogin = returnLoginStatus();
  const [openModal, setOpenModal] = useState(false);
  const withdrawalSuccess = useSelector(
    (state) => state.auth.withdrawalSuccess
  );
  const handleWithdrawal = () => {
    const params = {
      reason: "", // (required) 탈퇴사유
    };
    dispatch(authActions.fetchWithdrawal({ accessToken, params }));
  };

  useDidMountEffect(() => {
    if (withdrawalSuccess) {
      navigate("/mypage/withdrawal/result", { replace: true });
      // location.replace("/mypage/withdrawal/result");
    }
  }, [withdrawalSuccess]);

  return (
    <OnePageLayout title="회원 탈퇴">
      {openModal && (
        <FuncModal
          title={"회원탈퇴를 계속 진행 하시겠습니까?"}
          setOpenModal={setOpenModal}
          callbackFunc={handleWithdrawal}
        >
          <p>
            탈퇴시 MU Point 및 제휴사의
            <br />
            포인트 이용이 불가능합니다.
          </p>
        </FuncModal>
      )}
      <Section className="nonePaddingTop">
        {isLogin && <TopPointBanner />}
        <Content>
          <WithDrawalTextDiv>
            <p>회원 탈퇴 시 보유하신 뮤포인트는 모두 소멸됩니다.</p>
          </WithDrawalTextDiv>
          <CheckList>
            <ImgWrap imgwidth="15.1">
              <img src={withDrawalImg} alt="" />
            </ImgWrap>
            <List>
              <h3>탈퇴 전 체크</h3>
              <ul>
                <li>
                  뮤포인트를 탈퇴하시면 등록된 제휴사의 모든 포인트 이용이
                  불가합니다.
                </li>
                <li>재가입이 90일동안 제한됩니다.</li>
                <li>보유하신 포인트는 모두 소멸됩니다.</li>
                <li>
                  탈퇴와 관련된 모든 정책은 뮤포인트 회원가입시 동의한 이용약관
                  내용을 참고하시기 바랍니다.
                </li>
              </ul>
            </List>
          </CheckList>
        </Content>
        <TwoBtns>
          <ButtonS col="purple_dark" onClick={() => navigate(-1)}>
            취소
          </ButtonS>
          <ButtonS
            col="purple_dark"
            onClick={() => {
              setOpenModal(true);
            }}
          >
            신청
          </ButtonS>
        </TwoBtns>
      </Section>
    </OnePageLayout>
  );
};

export default WithDrawal;
const WithDrawalTextDiv = styled(TextDiv)`
  p {
    font-weight: 700;
    line-height: 1.4rem; /* 100% */
    color: ${({ theme }) => theme.color.pink};
  }
`;
const CheckList = styled.div`
  margin-top: 5rem;
  h3 {
    text-align: center;
    font-size: 1.4rem;
    line-height: 1.4rem;
  }
`;
const List = styled.div`
  padding: 2rem 3rem;
  border-radius: 1rem;
  background: ${({ theme }) => theme.color.purple_secondary};
  color: ${({ theme }) => theme.color.white};
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.1);
  margin-top: -0.5rem;
  ul {
    margin-top: 1rem;
    li {
      font-size: 1.2rem;
      line-height: 20px; /* 166.667% */
      letter-spacing: -0.6px;
      position: relative;
      &::before {
        content: "· ";
        position: absolute;
        left: -0.8rem;
      }
    }
  }
`;
